import { Tooltip, Typography } from 'primsell-shared-layer/components'

import * as S from './input-label.styles'

interface IInputLabelProps {
  label: string
  isRequired?: boolean
  tooltipTitle?: string
  helperText?: string
  rightHelperText?: string
}

const InputLabel = ({ label, isRequired = false, tooltipTitle, helperText, rightHelperText }: IInputLabelProps) => {
  return (
    <S.InputLabel>
      <S.LabelContainer>
        <Typography variant="input-label">{label}</Typography>
        {isRequired && <S.LabelMark>*</S.LabelMark>}
        {tooltipTitle && (
          <Tooltip content={tooltipTitle}>
            <S.TooltipIcon />
          </Tooltip>
        )}
        {rightHelperText && (
          <S.RightHelperTextTypography variant="caption" color="grey">
            {rightHelperText}
          </S.RightHelperTextTypography>
        )}
      </S.LabelContainer>
      {helperText && (
        <div>
          <Typography variant="input-helper-text" color="grey">
            {helperText}
          </Typography>
        </div>
      )}
    </S.InputLabel>
  )
}

export { InputLabel }
